export * from "./consent-recieved/consent-recieved.component"